// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Cadastro de Advogado ===== */
.advreg-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  background: var(--fundo);
}

.advreg-hero {
  position: relative;
  width: 42%;
  min-height: 100vh;
  padding: 56px 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(160deg, var(--azul-escuro) 0%, var(--azul) 55%, var(--azul2) 100%);
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.advreg-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 15% 15%, rgba(255, 255, 255, 0.12), transparent 45%),
    radial-gradient(circle at 85% 85%, rgba(255, 255, 255, 0.10), transparent 40%);
  pointer-events: none;
}

.advreg-hero-content {
  position: relative;
  z-index: 1;
  max-width: 420px;
}

.advreg-hero-logo {
  width: 60px;
  height: auto;
  margin-bottom: 24px;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.25));
}

.advreg-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .4px;
  text-transform: uppercase;
  margin-bottom: 18px;
}

.advreg-hero-content h1 {
  color: #fff;
  font-size: 30px;
  line-height: 1.25;
  margin: 0 0 14px;
}

.advreg-hero-content p {
  color: rgba(255, 255, 255, 0.82);
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 28px;
}

.advreg-hero-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.advreg-hero-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.advreg-hero-list li svg {
  color: var(--amarelo);
}

.advreg-hero-illustration {
  width: 200px;
  max-width: 60%;
  height: auto;
  opacity: .95;
  filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.25));
}

.advreg-form-side {
  width: 58%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 5%;
  box-sizing: border-box;
}

.advreg-card {
  position: relative;
  width: 100%;
  max-width: 640px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 24px;
  box-shadow: var(--ui-shadow-md);
  padding: 40px 44px 36px;
  box-sizing: border-box;
}

.advreg-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: 700;
  color: var(--ui-muted);
  box-shadow: none;
  max-height: none;
  opacity: 1;
  transition: color .2s ease;
}

.advreg-back:hover {
  color: var(--ui-primary);
  transform: none;
}

.advreg-card-header {
  margin-bottom: 28px;
}

.advreg-card-header h2 {
  margin: 0 0 6px;
  font-size: 24px;
}

.advreg-card-header p {
  color: var(--ui-muted);
  font-size: 14px;
  margin: 0;
}

.advreg-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.advreg-section-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .6px;
  color: var(--ui-primary);
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 1px dashed var(--ui-border);
}

.advreg-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.advreg-row + .advreg-row,
.advreg-row-uf + .advreg-row {
  margin-top: 16px;
}

.advreg-row-uf {
  grid-template-columns: 1fr 110px;
}

.advreg-row-full {
  grid-template-columns: 1fr;
}

.advreg-oab-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
  margin: 10px 0 0;
}

.advreg-oab-hint-loading {
  color: var(--ui-primary);
  font-weight: 700;
}

.advreg-oab-spinner {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  display: inline-block;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: advreg-oab-spin .7s linear infinite;
}

@keyframes advreg-oab-spin {
  to {
    transform: rotate(360deg);
  }
}

.advreg-oab-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 14px;
  background: var(--fundo2);
  border: 1px solid var(--texto-destaque);
  border-radius: var(--ui-radius-md);
}

.advreg-oab-box-icon {
  margin-top: 2px;
  color: var(--texto-destaque);
  flex-shrink: 0;
}

.advreg-oab-box strong {
  display: block;
  font-size: 13px;
  color: var(--texto-destaque);
}

.advreg-oab-box span {
  font-size: 12px;
  color: var(--texto);
}

.advreg-oab-box.advreg-oab-status-regular {
  background: var(--verde2);
  border-color: var(--verde);
}

.advreg-oab-box.advreg-oab-status-regular .advreg-oab-box-icon,
.advreg-oab-box.advreg-oab-status-regular strong {
  color: var(--verde);
}

.advreg-oab-box.advreg-oab-status-cancelado {
  background: var(--vermelho2);
  border-color: var(--Vermelho);
}

.advreg-oab-box.advreg-oab-status-cancelado .advreg-oab-box-icon,
.advreg-oab-box.advreg-oab-status-cancelado strong {
  color: var(--Vermelho);
}

.advreg-oab-box.advreg-oab-status-falecido {
  background: var(--fundo2);
  border-color: var(--azul);
}

.advreg-oab-box.advreg-oab-status-falecido .advreg-oab-box-icon,
.advreg-oab-box.advreg-oab-status-falecido strong {
  color: var(--azul);
}

.advreg-oab-box.advreg-oab-status-outro {
  background: var(--amarelo3);
  border-color: var(--amarelo2);
}

.advreg-oab-box.advreg-oab-status-outro .advreg-oab-box-icon,
.advreg-oab-box.advreg-oab-status-outro strong {
  color: var(--amarelo2);
}

.advreg-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.advreg-field label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
  margin: 0;
}

.advreg-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.advreg-input-icon {
  position: absolute;
  left: 14px;
  font-size: 14px;
  color: var(--ui-muted);
  pointer-events: none;
}

.advreg-card .advreg-input-wrap input,
.advreg-card .advreg-input-wrap select {
  width: 100%;
  padding: 12px 14px 12px 42px;
  font-size: 14px;
  background: var(--ui-input-bg);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  color: var(--ui-text);
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
}

.advreg-card .advreg-input-wrap input:focus,
.advreg-card .advreg-input-wrap select:focus {
  outline: none;
  border-color: rgba(3, 78, 162, 0.45);
  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.1);
}

.advreg-card .advreg-field-error .advreg-input-wrap input,
.advreg-card .advreg-field-error .advreg-input-wrap select {
  border-color: var(--Vermelho);
  background: #fff6f5;
}

.advreg-field-error .advreg-input-icon {
  color: var(--Vermelho);
}

.advreg-error {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--Vermelho);
}

.advreg-card .advreg-password-wrap input {
  padding-right: 42px;
}

.advreg-eye-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  padding: 4px;
  max-height: none;
  box-shadow: none;
  opacity: 1;
  color: var(--ui-muted);
  cursor: pointer;
}

.advreg-eye-btn:hover {
  color: var(--ui-primary);
  transform: none;
}

.advreg-strength {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.advreg-strength-bars {
  display: flex;
  gap: 4px;
  flex: 1 1;
}

.advreg-strength-bars span {
  height: 4px;
  flex: 1 1;
  border-radius: 999px;
  background: var(--ui-border);
}

.advreg-strength-bars span.filled-1 {
  background: var(--Vermelho);
}

.advreg-strength-bars span.filled-2 {
  background: var(--amarelo);
}

.advreg-strength-bars span.filled-3,
.advreg-strength-bars span.filled-4 {
  background: var(--verde);
}

.advreg-strength-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  white-space: nowrap;
}

.advreg-upload {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px;
  border: 1.5px dashed var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-input-bg);
  cursor: pointer;
  transition: border-color .2s ease, background .2s ease;
}

.advreg-upload:hover {
  border-color: var(--ui-primary);
}

.advreg-upload.has-error {
  border-color: var(--Vermelho);
}

.advreg-upload-preview {
  width: 56px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--ui-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.advreg-upload-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.advreg-upload-preview svg {
  color: var(--ui-muted);
  font-size: 18px;
}

.advreg-upload-text strong {
  display: block;
  font-size: 13px;
  color: var(--ui-text);
}

.advreg-upload-text span {
  font-size: 12px;
  color: var(--ui-muted);
}

.advreg-upload input[type="file"] {
  display: none;
}

.advreg-submit-btn {
  width: 100%;
  padding: 14px;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 700;
  border-radius: var(--ui-radius-md);
  background: var(--ui-primary);
  color: #fff;
  border: none;
  box-shadow: 0 10px 20px rgba(3, 78, 162, 0.22);
  max-height: none;
}

.advreg-submit-btn:disabled {
  opacity: .7;
  cursor: not-allowed;
  box-shadow: none;
}

.advreg-btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.advreg-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: advreg-spin .8s linear infinite;
  display: inline-block;
}

@keyframes advreg-spin {
  to {
    transform: rotate(360deg);
  }
}

.advreg-login-link {
  text-align: center;
  font-size: 13px;
  color: var(--ui-muted);
  margin-top: 4px;
}

.advreg-login-link a {
  color: var(--ui-primary);
  font-weight: 700;
}

@media (max-width: 1080px) {
  .advreg-hero-illustration {
    display: none;
  }
}

@media (max-width: 900px) {
  .advreg-page {
    flex-direction: column;
  }

  .advreg-hero,
  .advreg-form-side {
    width: 100%;
  }

  .advreg-hero {
    min-height: auto;
    padding: 40px 28px;
  }

  .advreg-form-side {
    padding: 32px 20px 48px;
  }

  .advreg-card {
    padding: 28px 22px;
  }
}

@media (max-width: 560px) {

  .advreg-row,
  .advreg-row-uf {
    grid-template-columns: 1fr;
  }
}

/* Advogado page */
.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-input,
.filter-select,
.filter-date {
  flex: 1 1;
  min-width: 180px;
  padding: 8px 12px !important;
}

.filter-date-range {
  display: flex;
  gap: 8px;
  flex: 2 1;
  min-width: 300px;
}

.filter-date-range .filter-date {
  flex: 1 1;
  min-width: 0;
}

.filter-input:focus, 
.filter-select:focus, 
.filter-date:focus {
  border-color: var(--azul2);
  background-color: #fff;
  outline: none;
}


@media (max-width: 768px) {
  .filters-container {
    flex-direction: column;
  }

  .filter-input, 
  .filter-select, 
  .filter-date {
    width: 100%; /* Ocupa toda a largura em telas pequenas */
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Advogado/advogado.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8FAA8F;EAC9F,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;kFAEgF;EAChF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;EAGE,SAAO;EACP,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;AACf;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW,EAAE,2CAA2C;EAC1D;AACF","sourcesContent":["/* ===== Cadastro de Advogado ===== */\n.advreg-page {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  background: var(--fundo);\n}\n\n.advreg-hero {\n  position: relative;\n  width: 42%;\n  min-height: 100vh;\n  padding: 56px 48px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: linear-gradient(160deg, var(--azul-escuro) 0%, var(--azul) 55%, var(--azul2) 100%);\n  color: #fff;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.advreg-hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at 15% 15%, rgba(255, 255, 255, 0.12), transparent 45%),\n    radial-gradient(circle at 85% 85%, rgba(255, 255, 255, 0.10), transparent 40%);\n  pointer-events: none;\n}\n\n.advreg-hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 420px;\n}\n\n.advreg-hero-logo {\n  width: 60px;\n  height: auto;\n  margin-bottom: 24px;\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.25));\n}\n\n.advreg-hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: .4px;\n  text-transform: uppercase;\n  margin-bottom: 18px;\n}\n\n.advreg-hero-content h1 {\n  color: #fff;\n  font-size: 30px;\n  line-height: 1.25;\n  margin: 0 0 14px;\n}\n\n.advreg-hero-content p {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 15px;\n  line-height: 1.6;\n  margin-bottom: 28px;\n}\n\n.advreg-hero-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.advreg-hero-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.advreg-hero-list li svg {\n  color: var(--amarelo);\n}\n\n.advreg-hero-illustration {\n  width: 200px;\n  max-width: 60%;\n  height: auto;\n  opacity: .95;\n  filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.25));\n}\n\n.advreg-form-side {\n  width: 58%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 5%;\n  box-sizing: border-box;\n}\n\n.advreg-card {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: 24px;\n  box-shadow: var(--ui-shadow-md);\n  padding: 40px 44px 36px;\n  box-sizing: border-box;\n}\n\n.advreg-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  padding: 0;\n  margin-bottom: 18px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  box-shadow: none;\n  max-height: none;\n  opacity: 1;\n  transition: color .2s ease;\n}\n\n.advreg-back:hover {\n  color: var(--ui-primary);\n  transform: none;\n}\n\n.advreg-card-header {\n  margin-bottom: 28px;\n}\n\n.advreg-card-header h2 {\n  margin: 0 0 6px;\n  font-size: 24px;\n}\n\n.advreg-card-header p {\n  color: var(--ui-muted);\n  font-size: 14px;\n  margin: 0;\n}\n\n.advreg-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.advreg-section-title {\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .6px;\n  color: var(--ui-primary);\n  margin: 0 0 14px;\n  padding-bottom: 8px;\n  border-bottom: 1px dashed var(--ui-border);\n}\n\n.advreg-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.advreg-row + .advreg-row,\n.advreg-row-uf + .advreg-row {\n  margin-top: 16px;\n}\n\n.advreg-row-uf {\n  grid-template-columns: 1fr 110px;\n}\n\n.advreg-row-full {\n  grid-template-columns: 1fr;\n}\n\n.advreg-oab-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ui-text);\n  margin: 10px 0 0;\n}\n\n.advreg-oab-hint-loading {\n  color: var(--ui-primary);\n  font-weight: 700;\n}\n\n.advreg-oab-spinner {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n  display: inline-block;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: advreg-oab-spin .7s linear infinite;\n}\n\n@keyframes advreg-oab-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.advreg-oab-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: var(--fundo2);\n  border: 1px solid var(--texto-destaque);\n  border-radius: var(--ui-radius-md);\n}\n\n.advreg-oab-box-icon {\n  margin-top: 2px;\n  color: var(--texto-destaque);\n  flex-shrink: 0;\n}\n\n.advreg-oab-box strong {\n  display: block;\n  font-size: 13px;\n  color: var(--texto-destaque);\n}\n\n.advreg-oab-box span {\n  font-size: 12px;\n  color: var(--texto);\n}\n\n.advreg-oab-box.advreg-oab-status-regular {\n  background: var(--verde2);\n  border-color: var(--verde);\n}\n\n.advreg-oab-box.advreg-oab-status-regular .advreg-oab-box-icon,\n.advreg-oab-box.advreg-oab-status-regular strong {\n  color: var(--verde);\n}\n\n.advreg-oab-box.advreg-oab-status-cancelado {\n  background: var(--vermelho2);\n  border-color: var(--Vermelho);\n}\n\n.advreg-oab-box.advreg-oab-status-cancelado .advreg-oab-box-icon,\n.advreg-oab-box.advreg-oab-status-cancelado strong {\n  color: var(--Vermelho);\n}\n\n.advreg-oab-box.advreg-oab-status-falecido {\n  background: var(--fundo2);\n  border-color: var(--azul);\n}\n\n.advreg-oab-box.advreg-oab-status-falecido .advreg-oab-box-icon,\n.advreg-oab-box.advreg-oab-status-falecido strong {\n  color: var(--azul);\n}\n\n.advreg-oab-box.advreg-oab-status-outro {\n  background: var(--amarelo3);\n  border-color: var(--amarelo2);\n}\n\n.advreg-oab-box.advreg-oab-status-outro .advreg-oab-box-icon,\n.advreg-oab-box.advreg-oab-status-outro strong {\n  color: var(--amarelo2);\n}\n\n.advreg-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.advreg-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ui-text);\n  margin: 0;\n}\n\n.advreg-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.advreg-input-icon {\n  position: absolute;\n  left: 14px;\n  font-size: 14px;\n  color: var(--ui-muted);\n  pointer-events: none;\n}\n\n.advreg-card .advreg-input-wrap input,\n.advreg-card .advreg-input-wrap select {\n  width: 100%;\n  padding: 12px 14px 12px 42px;\n  font-size: 14px;\n  background: var(--ui-input-bg);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  color: var(--ui-text);\n  box-sizing: border-box;\n  transition: border-color .2s ease, box-shadow .2s ease;\n}\n\n.advreg-card .advreg-input-wrap input:focus,\n.advreg-card .advreg-input-wrap select:focus {\n  outline: none;\n  border-color: rgba(3, 78, 162, 0.45);\n  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.1);\n}\n\n.advreg-card .advreg-field-error .advreg-input-wrap input,\n.advreg-card .advreg-field-error .advreg-input-wrap select {\n  border-color: var(--Vermelho);\n  background: #fff6f5;\n}\n\n.advreg-field-error .advreg-input-icon {\n  color: var(--Vermelho);\n}\n\n.advreg-error {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--Vermelho);\n}\n\n.advreg-card .advreg-password-wrap input {\n  padding-right: 42px;\n}\n\n.advreg-eye-btn {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  padding: 4px;\n  max-height: none;\n  box-shadow: none;\n  opacity: 1;\n  color: var(--ui-muted);\n  cursor: pointer;\n}\n\n.advreg-eye-btn:hover {\n  color: var(--ui-primary);\n  transform: none;\n}\n\n.advreg-strength {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.advreg-strength-bars {\n  display: flex;\n  gap: 4px;\n  flex: 1;\n}\n\n.advreg-strength-bars span {\n  height: 4px;\n  flex: 1;\n  border-radius: 999px;\n  background: var(--ui-border);\n}\n\n.advreg-strength-bars span.filled-1 {\n  background: var(--Vermelho);\n}\n\n.advreg-strength-bars span.filled-2 {\n  background: var(--amarelo);\n}\n\n.advreg-strength-bars span.filled-3,\n.advreg-strength-bars span.filled-4 {\n  background: var(--verde);\n}\n\n.advreg-strength-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  white-space: nowrap;\n}\n\n.advreg-upload {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px;\n  border: 1.5px dashed var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-input-bg);\n  cursor: pointer;\n  transition: border-color .2s ease, background .2s ease;\n}\n\n.advreg-upload:hover {\n  border-color: var(--ui-primary);\n}\n\n.advreg-upload.has-error {\n  border-color: var(--Vermelho);\n}\n\n.advreg-upload-preview {\n  width: 56px;\n  height: 72px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--ui-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.advreg-upload-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.advreg-upload-preview svg {\n  color: var(--ui-muted);\n  font-size: 18px;\n}\n\n.advreg-upload-text strong {\n  display: block;\n  font-size: 13px;\n  color: var(--ui-text);\n}\n\n.advreg-upload-text span {\n  font-size: 12px;\n  color: var(--ui-muted);\n}\n\n.advreg-upload input[type=\"file\"] {\n  display: none;\n}\n\n.advreg-submit-btn {\n  width: 100%;\n  padding: 14px;\n  margin-top: 4px;\n  font-size: 15px;\n  font-weight: 700;\n  border-radius: var(--ui-radius-md);\n  background: var(--ui-primary);\n  color: #fff;\n  border: none;\n  box-shadow: 0 10px 20px rgba(3, 78, 162, 0.22);\n  max-height: none;\n}\n\n.advreg-submit-btn:disabled {\n  opacity: .7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.advreg-btn-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.advreg-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: advreg-spin .8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes advreg-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.advreg-login-link {\n  text-align: center;\n  font-size: 13px;\n  color: var(--ui-muted);\n  margin-top: 4px;\n}\n\n.advreg-login-link a {\n  color: var(--ui-primary);\n  font-weight: 700;\n}\n\n@media (max-width: 1080px) {\n  .advreg-hero-illustration {\n    display: none;\n  }\n}\n\n@media (max-width: 900px) {\n  .advreg-page {\n    flex-direction: column;\n  }\n\n  .advreg-hero,\n  .advreg-form-side {\n    width: 100%;\n  }\n\n  .advreg-hero {\n    min-height: auto;\n    padding: 40px 28px;\n  }\n\n  .advreg-form-side {\n    padding: 32px 20px 48px;\n  }\n\n  .advreg-card {\n    padding: 28px 22px;\n  }\n}\n\n@media (max-width: 560px) {\n\n  .advreg-row,\n  .advreg-row-uf {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Advogado page */\n.filters-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.filter-input,\n.filter-select,\n.filter-date {\n  flex: 1;\n  min-width: 180px;\n  padding: 8px 12px !important;\n}\n\n.filter-date-range {\n  display: flex;\n  gap: 8px;\n  flex: 2;\n  min-width: 300px;\n}\n\n.filter-date-range .filter-date {\n  flex: 1;\n  min-width: 0;\n}\n\n.filter-input:focus, \n.filter-select:focus, \n.filter-date:focus {\n  border-color: var(--azul2);\n  background-color: #fff;\n  outline: none;\n}\n\n\n@media (max-width: 768px) {\n  .filters-container {\n    flex-direction: column;\n  }\n\n  .filter-input, \n  .filter-select, \n  .filter-date {\n    width: 100%; /* Ocupa toda a largura em telas pequenas */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
